import { elementSizeCssClass, none } from "../size/index.js";
import defineElement from "../helpers/defineElement.js";

/**
 * Wrap its children to add some space around it.
 *
 * @param {object} [options]
 * @param {ElementSize} [options.size] - Size of the space
 *   between each child
 * @param {boolean} [options.around] - When true, adds a gap around the whole element
 * @param {boolean} [options.top] - When true, adds a gap to the top of the whole
 *   element
 * @param {boolean} [options.right] - When true, adds a gap to the right of the whole
 *   element
 * @param {boolean} [options.bottom] - When true, adds a gap to the bottom of the whole
 *   element
 * @param {boolean} [options.left] - When true, adds a gap to the left of the whole
 *   element
 * @param {boolean} [options.isBlock] - When true, the theme acts as a block
 *   applying the text and background colors
 */

export default defineElement(
	"container",
	({
		size = none,
		around = undefined,
		top = around,
		right = around,
		bottom = around,
		left = around,
		isBlock = false,
	}) => {
		if (!around && !top && !left && !right && !bottom) {
			top = true;
			right = true;
			bottom = true;
			left = true;
		}

		return {
			options: {
				class: [
					{
						top,
						right,
						bottom,
						left,
						"is-block": isBlock,
					},
					elementSizeCssClass("space", size),
				],
			},
		};
	},
);
